module.exports = __webpack_public_path__ + "img/photos-integration-test.f3d63107.png";